import React, { PureComponent } from 'react';
import Lightbox from 'react-image-lightbox';
import ImageGallery from '../ReactImageGallery';

// import 'react-image-gallery/styles/css/image-gallery.css';
import 'react-image-lightbox/style.css';

const getImage = (image, type) => {
    if (image) {
        return image[type].src;
    }
    return 'https://fakeimg.pl/200/?text=plz add image';
};

export default class ProductImages extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showImageModal: false,
            currentImageIndex: 0,
        };
        this.galleryRef = React.createRef();
    }

    showImage = () => {
        const currentIndex = this.galleryRef.current.getCurrentIndex();
        this.setState({ currentImageIndex: currentIndex, showImageModal: true });
    }

    hideImageModal = () => {
        this.setState({
            showImageModal: false,
            currentImageIndex: 0,
        });
    }

    render() {
        const { images, name } = this.props;
        const { showImageModal, currentImageIndex } = this.state;
        const imageMapping = images.map((image, index) => ({
            original: getImage(image, 'fixed'),
            thumbnail: getImage(image, 'fixed'),
            originalAlt: `${name}-圖片-${index}`,
            thumbnailAlt: `${name}-圖片-${index}`,
        }));

        const modalImageMapping = images.map((image) => getImage(image, 'fluid'));

        return (
            <>
                <ImageGallery
                    ref={this.galleryRef}
                    onClick={this.showImage}
                    items={imageMapping}
                    showFullscreenButton={false}
                    useBrowserFullscreen={false}
                    showPlayButton={false}
                    showThumbnails={imageMapping.length > 1}
                />
                {showImageModal && (
                    <Lightbox
                        reactModalStyle={{ overlay: { zIndex: 10000 } }}
                        mainSrc={modalImageMapping[currentImageIndex]}
                        nextSrc={modalImageMapping[(currentImageIndex + 1) % modalImageMapping.length]}
                        prevSrc={modalImageMapping[(currentImageIndex + modalImageMapping.length - 1) % modalImageMapping.length]}
                        onCloseRequest={this.hideImageModal}
                        onMovePrevRequest={() => this.setState({
                            currentImageIndex: (currentImageIndex + images.length - 1) % images.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            currentImageIndex: (currentImageIndex + 1) % images.length,
                        })}
                    />
                )}
            </>
        );
    }
}
